interface MayflowerLogoProps {
  className?: string;
}

export function MayflowerLogo({ className = "h-8" }: MayflowerLogoProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 536.2 86.61"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>mayflower_logo</title>
      <path
        fill="#e75300"
        d="M176.32,28.43c1.76-1.49,4.25-.08,5.19,1.4s2.59,16.6,3.07,19.68c2.62,16.78,11.17,28.08,11.17,30.43,0,3.39-2.47,4.74-4.92,5.57,0,0-3.75,1.18-5.57,0-3-1.93-6.63-10.17-8.22-12.75-4-6.48-5.48-23.34-8.38-23.65-2.34-.26-32.23,42.73-31.48,45.29.54,2.57,3.23,2.54,4,2.64,8.1,1.07,23.77-2.68,25.3-3,5-1.1,16.07,0,16.07,0,2.66.27,7.09,2,6.92,5.14-.16,2.92-4.89,6.61-6.91,5.58a8.56,8.56,0,0,0-6-.63c-1.88,0-8.58,4.06-13.66,8.07-2.77,2.19-11.76,2.39-13.71,2.14-3.12-.4-12-5.23-15.52-7.5-1.55-1-11.64-9.13-13.81-12.85,0,0-3.65-6-4.28-8.13s.06-6.28,1-6.64c24-9.43,58.36-49.54,59.81-50.77Z"
        transform="translate(-43.71 -27.79)"
      />
      <polygon
        fill="#717271"
        points="30.41 67.48 47.05 29.63 47.19 29.63 53.67 66.3 60.82 66.3 49.48 8.43 30.41 52.16 11.34 8.43 0 66.3 7.14 66.3 13.62 29.63 13.77 29.63 30.41 67.48 30.41 67.48"
      />
      <polygon
        fill="#717271"
        points="174.8 42.15 174.8 66.3 181.72 66.3 181.72 42.15 199.83 10.79 191.88 10.79 178.26 34.49 164.64 10.79 156.69 10.79 174.8 42.15 174.8 42.15"
      />
      <polygon
        fill="#717271"
        points="241.72 17.12 241.72 10.79 214.85 10.79 214.85 66.3 221.77 66.3 221.77 39.05 241.06 39.05 241.06 32.73 221.77 32.73 221.77 17.12 241.72 17.12 241.72 17.12"
      />
      <polygon
        fill="#717271"
        points="265.57 10.79 258.65 10.79 258.65 66.3 282.43 66.3 282.43 59.97 265.57 59.97 265.57 10.79 265.57 10.79"
      />
      <path
        fill="#717271"
        fillRule="evenodd"
        d="M366.18,37.4a29.16,29.16,0,0,0-29.08,28.94,29.08,29.08,0,0,0,58.17,0A29.16,29.16,0,0,0,366.18,37.4Zm0,51.39A22.3,22.3,0,0,1,344,66.34c0-12.22,9.13-22.46,22.16-22.46s22.16,10.24,22.16,22.46a22.29,22.29,0,0,1-22.16,22.46Z"
        transform="translate(-43.71 -27.79)"
      />
      <polygon
        fill="#717271"
        points="366.93 10.79 359.42 10.79 382.47 68.5 398.15 27.79 413.83 68.5 436.88 10.79 429.37 10.79 413.83 50.54 398.15 9.61 382.47 50.54 366.93 10.79 366.93 10.79"
      />
      <polygon
        fill="#717271"
        points="451.53 66.3 481.35 66.3 481.35 59.97 458.45 59.97 458.45 38.98 480.69 38.98 480.69 32.65 458.45 32.65 458.45 17.12 481.35 17.12 481.35 10.79 451.53 10.79 451.53 66.3 451.53 66.3"
      />
      <path
        fill="#717271"
        fillRule="evenodd"
        d="M562.39,69.94c8-1,13.32-7.58,13.32-15.54a15.37,15.37,0,0,0-7.29-13.25c-4.42-2.5-9.72-2.58-14.65-2.58h-8.39V94.1h6.92V70.61h2.87L571.52,94.1h8.39L562.39,69.94ZM552.3,44.76h1.84c6.85,0,15.09,1.25,15.09,9.94s-7.66,10.16-14.72,10.16H552.3V44.76Z"
        transform="translate(-43.71 -27.79)"
      />
    </svg>
  );
}
